function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useFetcher } from 'react-router-dom';
import { t, Translate } from "../../../../../I18N";

import { InputField, Select, MultiSelect } from "../../../../Components/Forms";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { UserRole } from "../../../../../../shared/types/userSchema";
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { PermissionsListModal } from "./PermissionsListModal";












const userRoles = [
{ key: UserRole.ADMIN, value: UserRole.ADMIN },
{ key: UserRole.EDITOR, value: UserRole.EDITOR },
{
  key: UserRole.COLLABORATOR,
  value: UserRole.COLLABORATOR
}];


const isUnique = (nameVal, selectedUser, users) =>
!(users !== null && users !== void 0 && users.find(
  (existingUser) => {var _existingUser$usernam, _existingUser$email;return (
      existingUser._id !== (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser._id) && (
      ((_existingUser$usernam = existingUser.username) === null || _existingUser$usernam === void 0 ? void 0 : _existingUser$usernam.trim().toLowerCase()) === nameVal.trim().toLowerCase() ||
      ((_existingUser$email = existingUser.email) === null || _existingUser$email === void 0 ? void 0 : _existingUser$email.trim().toLowerCase()) === nameVal.trim().toLowerCase()));}
));

const calculateSelectedGroups = (selectedGroups, groups) =>
selectedGroups.map((selectedGroup) => {
  const group = groups === null || groups === void 0 ? void 0 : groups.find((originalGroup) => originalGroup.name === selectedGroup);
  return { _id: group === null || group === void 0 ? void 0 : group._id, name: group === null || group === void 0 ? void 0 : group.name };
});

const getFieldError = (field, type) => {
  if (field === 'username') {
    switch (type) {
      case 'required':
        return 'Username is required';
      case 'isUnique':
        return 'Duplicated username';
      case 'maxLength':
        return 'Username is too long';
      case 'minLength':
        return 'Username is too short';
      case 'noSpaces':
        return 'Usernames cannot have spaces';
      default:
        break;
    }
  }

  if (field === 'email') {
    switch (type) {
      case 'required':
        return 'Email is required';
      case 'validate':
        return 'Duplicated email';
      default:
        break;
    }
  }

  if (field === 'password' && type) {
    return 'Password is too long';
  }

  return undefined;
};

const UserFormSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  setSelected,
  selectedUser,
  users,
  groups
}) => {var _errors$username, _errors$email, _errors$password, _selectedUser$groups;
  const fetcher = useFetcher();
  const [showModal, setShowModal] = useState(false);

  const defaultValues = {
    username: '',
    email: '',
    password: '',
    role: 'collaborator',
    groups: []
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue
  } = useForm({
    defaultValues,
    values: selectedUser
  });

  const closeSidepanel = () => {
    reset(defaultValues);
    setSelected(undefined);
    setShowSidepanel(false);
  };

  const formSubmit = async (data) => {
    const formData = new FormData();
    if (data._id) {
      formData.set('intent', 'edit-user');
    } else {
      formData.set('intent', 'new-user');
    }

    formData.set('data', JSON.stringify(data));
    fetcher.submit(formData, { method: 'post' });
    setShowSidepanel(false);
    reset(defaultValues);
  };

  const onClickSubmit = (intent) => {
    const formData = new FormData();
    formData.set('intent', intent);
    formData.set('data', JSON.stringify(selectedUser));
    fetcher.submit(formData, { method: 'post' });

    setShowSidepanel(false);
    reset(defaultValues);
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: closeSidepanel,
      title: selectedUser ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit user") : /*#__PURE__*/_jsx(Translate, {}, void 0, "New user") }, void 0, /*#__PURE__*/

    _jsx("form", { onSubmit: handleSubmit(formSubmit), className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col flex-grow gap-4" }, void 0, /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "mb-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "block mb-1 font-semibold" }, void 0, "Username"),
      id: "username",
      errorMessage: getFieldError('username', (_errors$username = errors.username) === null || _errors$username === void 0 ? void 0 : _errors$username.type),
      autoComplete: "off",
      className: "mb-1" },
    register('username', {
      required: true,
      validate: {
        isUnique: (username) => isUnique(username, selectedUser, users),
        noSpaces: (username) => !/\s/.test(username)
      },
      maxLength: 50,
      minLength: 3
    }))
    )
    ), /*#__PURE__*/

    React.createElement(Select, _extends({
      label: /*#__PURE__*/
      _jsx("div", { className: "flex gap-2 mb-1 font-semibold align-middle" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "User Role"), /*#__PURE__*/
      _jsx("button", { type: "button", onClick: () => setShowModal(true) }, void 0, /*#__PURE__*/
      _jsx("span", { className: "sr-only" }, void 0, t('System', 'Permission', null, false)), /*#__PURE__*/
      _jsx(QuestionMarkCircleIcon, { className: "w-5" })
      )
      ),

      className: "mb-4",
      id: "roles",
      options: userRoles },
    register('role'))
    ), /*#__PURE__*/

    _jsx("div", {}, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "block mb-1 font-semibold" }, void 0, "Email"),
      type: "email",
      autoComplete: "off",
      id: "email",
      className: "mb-1",
      errorMessage: getFieldError('email', (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) },
    register('email', {
      required: true,
      validate: (email) => isUnique(email, selectedUser, users),
      maxLength: 256
    }))
    )
    )
    ), /*#__PURE__*/

    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Security") }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/
      _jsx("span", { className: "mb-1 font-semibold" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Password")
      ),

      id: "password",
      type: "password",
      autoComplete: "off",
      errorMessage: getFieldError('password', (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.type),
      className: "mb-4" },
    register('password', { maxLength: 50 }))
    ), /*#__PURE__*/

    _jsx("div", { className: "flex flex-col gap-1 w-fit md:with-full md:gap-4 md:flex-row md:justify-start" }, void 0,
    (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser._id) && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "light",
      onClick: () => onClickSubmit('reset-password') }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Reset Password")
    ), /*#__PURE__*/

    _jsx(Button, {
      type: "button",
      styling: "light",
      onClick: () => onClickSubmit('reset-2fa') }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Reset 2FA")
    )
    ),


    (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.accountLocked) && /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "light",
      color: "error",
      onClick: () => onClickSubmit('unlock-user') }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Unlock account")
    )

    )
    ), /*#__PURE__*/

    _jsx("div", { className: "border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      label: /*#__PURE__*/
      _jsx(Translate, { className: "block w-full text-base font-semibold bg-gray-50 text-primary-700" }, void 0, "Groups"

      ),

      onChange: (selectedGroups) => {
        const values = calculateSelectedGroups(selectedGroups, groups);
        setValue('groups', values, { shouldDirty: true });
      },
      options: (groups === null || groups === void 0 ? void 0 : groups.map((group) => ({ label: group.name, value: group.name }))) || [],
      value: (selectedUser === null || selectedUser === void 0 ? void 0 : (_selectedUser$groups = selectedUser.groups) === null || _selectedUser$groups === void 0 ? void 0 : _selectedUser$groups.map((userGroup) => userGroup.name)) || [],
      placeholder: "Nothing selected" }
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      className: "flex-grow",
      type: "button",
      styling: "outline",
      onClick: closeSidepanel }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(PermissionsListModal, { showModal: showModal, closeModal: () => setShowModal(false) })
    ));

};

export { UserFormSidepanel };